"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
/* eslint-disable camelcase */
const chart_scatter_active_size_1 = tslib_1.__importDefault(require("@patternfly/react-tokens/dist/js/chart_scatter_active_size"));
const chart_scatter_size_1 = tslib_1.__importDefault(require("@patternfly/react-tokens/dist/js/chart_scatter_size"));
// Donut styles
exports.ScatterStyles = {
    activeSize: chart_scatter_active_size_1.default.value,
    size: chart_scatter_size_1.default.value
};
//# sourceMappingURL=scatter-styles.js.map